const SESSION_KEY_PREFIX = 'zalena_session';
const POPUP_STATE_PREFIX = 'zalena_popup';
const SESSION_TIMEOUT_MS = 15 * 60 * 1000; // 15 minutes
function getSessionKey(widgetId) {
    return `${SESSION_KEY_PREFIX}_${widgetId || 'default'}`;
}
function getPopupKey(widgetId) {
    return `${POPUP_STATE_PREFIX}_${widgetId || 'default'}`;
}
export function loadSession(widgetId) {
    try {
        const raw = sessionStorage.getItem(getSessionKey(widgetId));
        if (!raw)
            return null;
        const session = JSON.parse(raw);
        if (Date.now() - session.lastActivity > SESSION_TIMEOUT_MS) {
            clearSession(widgetId);
            return null;
        }
        return session;
    }
    catch (_a) {
        return null;
    }
}
export function saveSession(session, widgetId) {
    try {
        sessionStorage.setItem(getSessionKey(widgetId), JSON.stringify(session));
    }
    catch (_a) {
        // sessionStorage full or unavailable
    }
}
export function updateSessionToken(token, serverUrl, widgetId) {
    const session = loadSession(widgetId);
    if (session) {
        session.participantToken = token;
        session.serverUrl = serverUrl;
        session.lastActivity = Date.now();
        saveSession(session, widgetId);
    }
}
export function appendMessage(msg, widgetId) {
    const session = loadSession(widgetId);
    if (session) {
        const existingIndex = session.messages.findIndex((m) => m.id === msg.id);
        if (existingIndex >= 0) {
            session.messages[existingIndex] = msg;
        }
        else {
            session.messages.push(msg);
        }
        session.lastActivity = Date.now();
        saveSession(session, widgetId);
    }
}
/**
 * Batch-persist all messages in a single read → modify → write cycle.
 * Avoids N separate sessionStorage round-trips that appendMessage would cause.
 */
export function batchPersistMessages(msgs, widgetId) {
    const session = loadSession(widgetId);
    if (!session)
        return;
    const idxMap = new Map();
    for (let i = 0; i < session.messages.length; i++) {
        idxMap.set(session.messages[i].id, i);
    }
    for (const msg of msgs) {
        const idx = idxMap.get(msg.id);
        if (idx !== undefined) {
            session.messages[idx] = msg;
        }
        else {
            idxMap.set(msg.id, session.messages.length);
            session.messages.push(msg);
        }
    }
    session.lastActivity = Date.now();
    saveSession(session, widgetId);
}
export function clearSession(widgetId) {
    try {
        sessionStorage.removeItem(getSessionKey(widgetId));
        sessionStorage.removeItem(getPopupKey(widgetId));
    }
    catch (_a) {
        // ignore
    }
}
export function setPopupState(open, widgetId) {
    try {
        sessionStorage.setItem(getPopupKey(widgetId), open ? '1' : '0');
    }
    catch (_a) {
        // ignore
    }
}
export function getPopupState(widgetId) {
    try {
        return sessionStorage.getItem(getPopupKey(widgetId)) === '1';
    }
    catch (_a) {
        return false;
    }
}
